import "./footer.scss";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="wrapper">
        <div className="container">
          <div className="copyright">
            <p>Copyright © {year} Nagwa</p>
            <p>All Rights Reserved</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
